import React from 'react';
import { Layout, Seo } from '@layout';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';

import styled from 'styled-components';
import { themeColor } from '@utils/styledTheme.util';
import BulletIcon from '@images/bullet-icon.svg';

const LegalPageWrapper = styled(Box)`
  color: ${themeColor('purple6')};
  h1,
  h2 {
    text-align: center;
  }
  h1,
  h3 {
    margin-bottom: 32px;
  }
  h2:last-of-type {
    margin-bottom: 80px;
  }
  h5 {
    margin-bottom: 0;
  }
  h3 {
    margin-top: 64px;
  }
  a {
    color: ${themeColor('linkDefault')};
    &:hover {
      color: ${themeColor('linkHover')};
    }
    &:active {
      color: ${themeColor('linkPress')};
    }
  }
  ol {
    list-style: decimal;
    li {
      margin-left: 10px;
      margin-bottom: 24px;
      span:first-child {
        margin-right: 8px;
      }
    }
  }
  ul {
    li {
      position: relative;
      margin-left: 20px;
      margin-bottom: 24px;
      span:first-child {
        margin-right: 8px;
      }
      &::before {
        position: absolute;
        top: 7px;
        left: -42px;
        content: '';
        height: 12px;
        width: 12px;
        background-image: url(${BulletIcon});
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }
`;

interface LegalPageProps
  extends Readonly<{
    seoTitle: string;
    children: React.ReactNode;
  }> {}

export const LegalPage: React.FC<LegalPageProps> = ({ seoTitle, children }) => {
  return (
    <Layout>
      <Seo title={seoTitle} canonicalURL={seoTitle === 'EULA' ? 'https://withjoy.com/EULA/' : undefined} />
      <Columns centered={true}>
        <Columns.Column width={7}>
          <LegalPageWrapper paddingY={10} paddingX={[4, 0, 6]}>
            {children}
          </LegalPageWrapper>
        </Columns.Column>
      </Columns>
    </Layout>
  );
};
